<template>
	<CardComponent :bordered="true" padding="md">
		<div class="space-y-6">
			<div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
				<div
					v-for="(action, index) in claimActions"
					:key="index"
					class="bg-white border border-border rounded-lg p-4 space-y-3"
				>
					<div>
						<p class="text-xs text-text-secondary mb-1">Name</p>
						<p class="text-sm font-medium text-text-primary">
							{{ action.name }}
						</p>
					</div>
					<div>
						<p class="text-xs text-text-secondary mb-1">Remarks</p>
						<p class="text-sm font-medium text-text-primary">
							{{ action.remarks }}
						</p>
					</div>
					<div>
						<p class="text-xs text-text-secondary mb-1">Status</p>
						<span
							class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
							:class="getActionStatusClass(action.action)"
						>
							{{ action.action }}
						</span>
					</div>
					<div class="flex gap-2 pt-2">
						<button
							@click="rejectAction(action)"
							class="flex-1 px-3 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors"
						>
							Reject
						</button>
						<button
							@click="approveAction(action)"
							class="flex-1 px-3 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors"
						>
							Approve
						</button>
					</div>
				</div>
			</div>
		</div>
	</CardComponent>
</template>

<script>
import CardComponent from '../Card.vue';

export default {
	name: 'ActionsTab',
	components: {
		CardComponent,
	},
	data() {
		return {
			claimActions: [
				{
					name: 'Satisfactory Note',
					remarks: 'Well done',
					action: 'Pending',
				},
				{
					name: 'Initial Assessment',
					remarks: 'Documents verified',
					action: 'Completed',
				},
				{
					name: 'Final Review',
					remarks: 'Awaiting approval',
					action: 'In Progress',
				},
			],
		};
	},
	methods: {
		getActionStatusClass(status) {
			const statusMap = {
				Pending: 'bg-amber-50 text-amber-700',
				Completed: 'bg-emerald-50 text-emerald-700',
				'In Progress': 'bg-blue-50 text-blue-700',
				Rejected: 'bg-red-50 text-red-700',
			};
			return statusMap[status] || 'bg-gray-50 text-gray-700';
		},
		rejectAction(action) {
			console.log('Rejecting action:', action);
			this.$emit('action-rejected', action);
		},
		approveAction(action) {
			console.log('Approving action:', action);
			this.$emit('action-approved', action);
		},
	},
};
</script>

<style scoped></style>
